import React from 'react';

type Props = {
  status: string;
};
const MemberStatus = ({ status }: Props) => {
  return (
    <div
      className={`flex gap-1 items-center ${
        status === 'pending' ? 'text-[#FF9500]' : 'text-[#3FB827]'
      }`}>
      <div
        className={`w-2 h-2 rounded-full ${
          status === 'pending' ? 'bg-[#FF9500]' : 'bg-[#3FB827]'
        }`}></div>
      <p className='capitalize text-sm'>{status}</p>
    </div>
  );
};

export default MemberStatus;
